import { devLogger } from '../utils/logger';

const createEventBus = () => {
  let registeredEventsHandlers = {};
  let context = {};

  const registerEvents = (events = []) => {
    const currentRegisteredEventsHandlers = registeredEventsHandlers;

    registeredEventsHandlers = events.reduce(
      (eventsHandlersObject, event) => {
        return {
          ...eventsHandlersObject,
          [event]: [],
        };
      },
      { ...currentRegisteredEventsHandlers }
    );
  };

  const registerEventHandler = (eventName, handler) => {
    registeredEventsHandlers[eventName] = [
      ...(registeredEventsHandlers[eventName] || []),
      handler,
    ];
  };

  const unregisterAllEvents = () => {
    Object.entries(registeredEventsHandlers).forEach(
      ([eventName, handlersArray]) => {
        handlersArray.forEach((handler) => {
          document.removeEventListener(eventName, handler);
        });
      }
    );
  };

  const dispatch = (eventName, payload = {}) => {
    context = { ...context, ...payload };
    devLogger(`Event dispatched: ${eventName}`, { payload, context });
    const newEvent = new CustomEvent(eventName, {
      detail: { payload, context },
    });
    document.dispatchEvent(newEvent);
  };

  const on = (eventName, handler) => {
    const handlerWrapper = (event) => {
      handler(event.detail.payload, event.detail.context);
    };
    registerEventHandler(eventName, handlerWrapper);
    document.addEventListener(eventName, handlerWrapper);
  };

  window.addEventListener('beforeunload', unregisterAllEvents);

  return {
    registerEvents,
    dispatch,
    on,
  };
};

// Available globally as EVENT_BUS via webpack
export const { registerEvents, dispatch, on } = createEventBus();
